import { QUERY_KEY_MY_MONITORING_GET_SITE_EVENTS_INFINITE } from '@apps-common/apis/my-monitoring/site'
import { QUERY_MY_MONITORING_GET_SITE_USERS, QUERY_MY_MONITORING_GET_SYSTEM_USER } from '@apps-common/apis/my-monitoring/users'
import { QUERY_GET_UNIT_TRAFFIC_INFINITE } from '@apps-common/apis/portal/unit'
import { QUERY_GET_UNIT_SITE_USER, QUERY_GET_UNIT_SITE_USERS } from '@apps-common/apis/portal/users'
import {
  SystemUserAddNewForm,
  SystemUserUpdateForm
} from '@apps-common/apps/portal/pages/units/pages/manage/pages/users/modals/system-user-modify-modal'
import { ModalCloseButton, ModalContainer, ModalHeader, ModalHeaderContainer } from '@apps-common/components/modals/modal'
import { ModalDismiss } from '@apps-common/config/modal'
import { queryClient } from '@apps-common/lib'

export interface ISystemUserModifyModalProps {
  unit: {
    unitId: string
    ipAddress: string
  }
  userId?: number
}

export const SystemUserModifyModal = ({
  onDismiss,
  componentProps
}: {
  onDismiss: (data?: string | null | undefined | number, role?: string) => void
  componentProps: ISystemUserModifyModalProps
}) => {
  const { unit, userId } = componentProps
  const { unitId, ipAddress } = unit || {}
  const isEditing = userId !== undefined

  const refetchQueries = (role: string) => {
    if (role === ModalDismiss.Confirm) {
      // my monitoring
      queryClient.invalidateQueries({ queryKey: QUERY_MY_MONITORING_GET_SYSTEM_USER(userId, unitId) })
      queryClient.invalidateQueries({ queryKey: QUERY_MY_MONITORING_GET_SITE_USERS(unitId) })
      queryClient.invalidateQueries({ queryKey: QUERY_KEY_MY_MONITORING_GET_SITE_EVENTS_INFINITE() })
      // portal
      queryClient.invalidateQueries({ queryKey: QUERY_GET_UNIT_SITE_USER(userId, unitId) })
      queryClient.invalidateQueries({ queryKey: QUERY_GET_UNIT_SITE_USERS(unitId) })
      queryClient.invalidateQueries({ queryKey: QUERY_GET_UNIT_TRAFFIC_INFINITE() })
    }
  }

  return (
    <ModalContainer innerClasses='!min-h-0 !h-auto'>
      <ModalHeaderContainer>
        <div className='flex items-start justify-between'>
          <ModalHeader subtitle={isEditing ? 'Update' : 'Create'} title='System user' />
          <ModalCloseButton closeModal={() => onDismiss(null, ModalDismiss.Cancel)} />
        </div>
      </ModalHeaderContainer>

      {!isEditing && (
        <SystemUserAddNewForm
          uId={unitId}
          closeCb={(role: string) => {
            refetchQueries(role)
            onDismiss(null, role)
          }}
        />
      )}
      {isEditing && (
        <SystemUserUpdateForm
          userId={userId}
          unitId={unitId}
          closeCb={(role: string) => {
            refetchQueries(role)
            onDismiss(null, role)
          }}
        />
      )}
    </ModalContainer>
  )
}
